/* Dependencies for  Option Widget Print*/
var jQuery = require('jquery');
var validator = require('validator');
/*
 * Dependencie for makeSendtoLink
 * Dependencies
 */
var $ = require('jquery');
var urlValidationRegex = /^[\/.?=a-zA-Z0-9_-]*$/ig;
/*
 * Main method
 */
var makeSendtoLink = {
  initialize: function($element) {
    var _self = this;
    var p = { //set the default values for the options
      country:  '',
      domain:   '',
      popupsize: '2'
    };
    $element.on('click', function(e) {
      e.preventDefault();
      _self.clickSendToLink(this, p);
    });
  },

  clickSendToLink: function(element, p) {
    //Gets the data from link
    var metadataValues = $(element).data('options');
    if (metadataValues) {
      if (metadataValues.country)//Check if country is not defined
      {
        p.country = metadataValues.country;
      }
      if (metadataValues.domain) // Check if domain is not defined
      {
        p.domain = metadataValues.domain;
      }
      if (metadataValues.popupsize)//Check if popupsize is not defined
      {
        p.popupsize = metadataValues.popupsize;
      }
    }
    var url = $(element).attr('href');//Gets the url from the href
    this.sendto(p.country, p.domain, url, p.popupsize);
  },

  /**
   * This function builds the full url and opens it in a new window.
   * @param {Object} event Event object of target element
   * @returns {Object} Current component instance
   */
  sendToLink: function _sendToLink(event) {
    event.preventDefault();
    event.stopPropagation();
    var element = $(event.currentTarget), options = {};
    options.country = element.data('country');
    options.brand = element.data('brand');
    options.uri = element.attr('href');
    options.popupCode = element.attr('data-popup-code');
    this.sendto(options.country, options.brand, options.uri, options.popupCode);
  },
  
  sendto: function(country, brand, uri, popupCode) {
    var brandName = new String(brand);
    var protocol = window.location.protocol;
    var forwardUrl = new String('');
    var usDomain = new String('.com');
    var protectedServ = '/ProtectedServlet?returnTo=';

    if (brand == null || brand == '' || brand == 'no_brand' || brand == 'default_domain' || brand.toLowerCase() == 'marriott') {
      brandName = window.location.host;
      if (brand == 'default_domain' || brand.toLowerCase() == 'marriott') {
        var temp = new Array();
        temp = brandName.split('.', 2);

        if (temp[0] == 'www') {
          if (temp[1] == 'marriotthotels') {
            brandName = 'www.marriott';
          } else if (temp[1] == 'espanol') {
            tempLaca = brandName.split('.', 3);
            brandName = 'www.'  + tempLaca[2];
          } else {
            brandName = 'www.' + temp[1];
          }
        } else if (temp[0] == 'espanol') {
          brandName = temp[1];
        } else {
          brandName = temp[0];
        }

        brandName = brandName.concat(usDomain);
      }
    } else {
      brandName = brandName.toLowerCase();

      if (country == null || country == '') {
        country == 'us';
      }
      country = country.toLowerCase();

      switch (country) {
        case 'br':
          brandName = brandName + '.br';
          break;
        case 'pt':
          brandName = brandName + '.pt';
          break;
        case 'fr':
          brandName = brandName + '.fr';
          break;
        case 'au':
          brandName = brandName + '.com.au';
          break;
        case 'kr':
          brandName = brandName + '.co.kr';
          break;
        case 'cn':
          brandName = brandName + '.com.cn';
          break;
        case 'nz':
          brandName = brandName + '.co.nz';
          break;
        case 'de':
          brandName = brandName + '.de';
          break;
        case 'jp':
          brandName = brandName + '.co.jp';
          break;
        case 'uk':
          brandName = brandName + '.co.uk';
          break;
        case 'mx':
          brandName = brandName + '.com.mx';
          break;
        case 'ar':
          brandName = brandName + '.com.ar';
          break;
        case 'cl':
          brandName = brandName + '.cl';
          break;
        case 'cr':
          brandName = brandName + '.co.cr';
          break;
        case 'do':
          brandName = brandName + '.com.do';
          break;
        case 'pe':
          brandName = brandName + '.com.pe';
          break;
        case 've':
          brandName = brandName + '.co.ve';
          break;
        case 'la1':
        case 'la2':
        case 'gt':
        case 'ec':
        case 'ni':
        case 'uy':
          brandName = 'espanol.marriott.com';
          break;
        default:
          brandName = brandName + '.com';
          break;
      }
    }

    forwardUrl = protocol + '//' + brandName;

    // When the URL includes '/ProtectedServlet?returnTo=' and is passed into the sendTo() function,
    // it decodes any special character that was originally meant to be encoded. The following encodes those characters back.
    var uriName = uri;
    if (uriName.indexOf(protectedServ) != -1) {
      var returnToUrl = escape(uriName.substring(uriName.indexOf('=') + 1));
      uri = protectedServ + returnToUrl;
    }

    if (uri != null) {
      if (uri.indexOf(forwardUrl) === -1) {
        forwardUrl = forwardUrl + uri;
      } else {
        forwardUrl = uri;
      }
    }

    //determine window type
    switch (popupCode) {
      case '2':
        var protocol = 'http';
        if (uri.substr(0, protocol.length) == protocol) {
          window.open(uri, '_blank');
        } else {
          window.open(forwardUrl, '_blank');
        }
        break;
      case '3':
        window.open(forwardUrl, '_blank');
        break;
      case '4':
        window.open(forwardUrl, '_blank', 'width=235,height=206,scrollbars=no,menubar=no,toolbar=no,status=no,resizable=yes');
        break;
      case '5':
        window.open(forwardUrl, '_blank', 'width=383,height=585,scrollbars=yes,menubar=no,toolbar=no,status=no,resizable=yes');
        break;
      case '6':
        window.open(forwardUrl, '_blank', 'width=350,height=475,scrollbars=no,menubar=no,toolbar=no,status=no,resizable=yes');
        break;
      case '7':
        window.open(forwardUrl, '_blank', 'width=352,height=306,scrollbars=no,menubar=no,toolbar=no,status=no,resizable=yes');
        break;
      case '8':
        window.open(forwardUrl, '_blank', 'width=575,height=385,scrollbars=yes,menubar=no,toolbar=no,status=no,resizable=yes');
        break;
      case '9':
        window.open(forwardUrl, '_blank', 'width=570,height=560,scrollbars=yes,menubar=no,toolbar=no,status=no,resizable=yes');
        break;
      case '10':
        window.opener.location(forwardUrl);
        window.close();
        break;
      case '11':
        window.open(forwardUrl, '_blank', '');
        window.close();
        break;
      case '12':
        window.open(forwardUrl, 'imagePopUp', 'width=590,height=413,scrollbars=yes,menubar=no,toolbar=no,status=no,resizable=yes');
        break;
      case '13':
        window.open(forwardUrl, '_blank', 'width=630,height=500,scrollbars=yes,menubar=no,toolbar=no,status=no,resizable=yes');
        break;
      case '14':
        window.open(uri, 'imagePopUp', 'width=572,height=410,scrollbars=yes,menubar=no,toolbar=no,status=no,resizable=yes');
        break;
      case '15':
        window.open(forwardUrl, '_blank', 'width=575,height=385,scrollbars=yes,menubar=yes,toolbar=yes,status=yes,resizable=yes');
        break;
      case '16':
        window.open(forwardUrl, '_blank', 'width=610,height=535,scrollbars=yes,menubar=no,toolbar=no,status=no,resizable=yes');
        break;
      case '17':
        window.open(forwardUrl, '_blank', 'width=500,height=480,scrollbars=no,menubar=no,toolbar=no,status=no,resizable=no');
        break;
      case '18':
        window.open(forwardUrl, 'imagePopUp', 'width=590,height=472,scrollbars=yes,menubar=no,toolbar=no,status=no,resizable=yes');
        break;
      case '19':
        window.open(uri, 'popUp', 'scrollbars=yes,menubar=yes,toolbar=yes,status=yes,resizable=yes');
        break;
      case '20':
        window.open(uri, 'imagePopUp', 'width=552,height=480,scrollbars=no,menubar=no,toolbar=no,status=no,resizable=no');
        break;
      case '21':
        window.open(forwardUrl, '_blank', 'width=900,height=600,scrollbars=yes,menubar=no,toolbar=no,status=no,resizable=yes');
        break;
      case '22':
        window.open(forwardUrl, '_blank', 'width=400,height=250,scrollbars=yes,menubar=no,toolbar=no,status=no,resizable=yes');
        break;
      case '23':
        window.open(forwardUrl, 'imagePopUp', 'width=753,height=660,scrollbars=yes,menubar=no,toolbar=no,status=no,resizable=yes');
        break;
      case '24':
        window.open(forwardUrl, '_blank', 'width=695,height=560,scrollbars=yes,menubar=no,toolbar=no,status=no,resizable=yes');
        break;
      case '25':
        window.open(uri, '_blank', 'width=570,height=560,scrollbars=yes,menubar=no,toolbar=no,status=no,resizable=yes');
        break;
      case '26':
        window.open(forwardUrl, '_blank', 'width=570,height=600,scrollbars=yes,menubar=no,toolbar=no,status=no,resizable=yes');
        break;
      case '27':
        window.open(forwardUrl, '_blank', 'width=570,height=220,scrollbars=yes,menubar=no,toolbar=no,status=no,resizable=yes');
        break;
      default:
        if(validator.match(forwardUrl, urlValidationRegex)){
          window.location.href = forwardUrl;
        }
        break;
    }
  }
};

module.exports = makeSendtoLink;
